import React, { Component, PropTypes } from 'react'


export class Pagination extends Component {

  constructor(props) {
    super(props)
    this.state = {
      inputPage: ''
    }
  }

  range() {
    const input = []
    const { page, perPage, total,linkPrefix } = this.props
    if (isNaN(page)) return input
    const nbPages = Math.ceil(total / perPage) || 1

    // display page links around the current page
    if (page > 2) {
      input.push('1')
    }
    if (page === 4) {
      input.push('2')
    }
    if (page > 4) {
      input.push('.')
    }
    if (page > 1) {
      input.push(page - 1)
    }
    input.push(page)
    if (page < nbPages) {
      input.push(page + 1)
    }
    if (page === (nbPages - 3)) {
      input.push(nbPages - 1)
    }
    if (page < (nbPages - 3)) {
      input.push('.')
    }
    if (page < (nbPages - 1)) {
      input.push(nbPages)
    }

    return input

    // for ( let i = 0; i < nbPages; i++ ) {
    //   input.push(i + 1)
    // }

  }

  getNbPages() {
    return Math.ceil(this.props.total / this.props.perPage) || 1
  }

  prevPage = (event) => {
    event.stopPropagation()
    if (this.props.page === 1) {
      throw new Error('Cannot go before page 1')
    }
    this.props.setPage(this.props.page - 1)
  }

  nextPage = (event) => {
    event.stopPropagation()
    if (this.props.page > this.getNbPages()) {
      throw new Error('Cannot after last page')
    }
    this.props.setPage(this.props.page + 1)
  }

  gotoPage = (event) => {
    event.stopPropagation()
    const page = Number(event.currentTarget.id)
    if (page < 1 || page > this.getNbPages()) {
      return
      // throw new Error(`Page number ${page} out of boundaries`)
    }
    this.props.setPage(page)
  }

  pageLink=(pageNum)=>{
    let urls=this.props.linkPrefix && this.props.linkPrefix.split('/')
    let locations=window.location && window.location.host.split('.')
    if(urls[2]!='news' && urls[2]!='loaninfodetail' ){//TBD 新闻和借款资讯做seo 单独给一个href 地址
      return 'javascript:void(0)'
    }
    if((locations && !/^(ztx2|ztx1|127|localhost)$/.test(locations[0])) || !locations){//ztx2|ztx1|127分别uat,sit,本地
      let childerUrl=''
      childerUrl=urls[2]=='news'?'aboutUs/newsinfo/':'aboutUs/loaninfo/'
    //  return 'http://'+urls[2]+'.chinatopcredit.com/'+childerUrl+'show-'+id+'.html'
    return 'https://www.chinatopcredit.com/'+childerUrl+'list-'+pageNum+'.html'
    }else{
      return (urls[2]=='news'?'aboutUs/newsinfo/':'aboutUs/loaninfo/' )+'list-'+pageNum+'.html'
    }
  }

  renderPageNums() {
    const page = this.props.page
    let urls=this.props.linkPrefix && this.props.linkPrefix.split('/')
    return this.range().map((pageNum, index) =>
        (pageNum === '.') ?
        <li key={index}>...</li> :
            <li key={index}><a  href={this.pageLink(pageNum)}
              className={pageNum === page ? 'cur' : null}
              style={{cursor: 'pointer'}} id={pageNum} onClick={this.gotoPage} title={`第${pageNum}页`}>{pageNum}</a></li>
    )
  }

  onChange = (event) => {
    this.setState({
      inputPage: event.target.value
    })
  }

  render() {
    const { page, perPage, total } = this.props
    if (total === 0) return null
    const offsetEnd = Math.min(page * perPage, total)
    const offsetBegin = Math.min((page - 1) * perPage + 1, offsetEnd)
    const nbPages = this.getNbPages()

    return (
      <div className="pagesCon clearfix">
        <ul className="pages clearfix">
            {/*<li className="firstPage"><a id={1} href={this.pageLink(1)} onClick={this.gotoPage} style={{cursor: 'pointer'}}>首页</a></li>*/}
            <li><a id={page - 1} href={this.pageLink(page==1?page:page-1)} onClick={this.gotoPage} style={{cursor:'pointer'}}>上一页</a> </li>
            {this.renderPageNums()}
            <li><a id={page + 1} href={this.pageLink(page + 1)} onClick={this.gotoPage} style={{cursor:'pointer'}}>下一页</a> </li>
            {/*<li className="endPage"><a id={nbPages} href={this.pageLink(nbPages)} onClick={this.gotoPage} style={{cursor: 'pointer'}} title="末页" className="">末页</a></li>*/}
         </ul>
         {/*<p className="fr clearfix">*/}
           {/*<span>跳转至</span>*/}
           {/*<input type="text"*/}
             {/*value={this.state.inputPage}*/}
             {/*onChange={this.onChange}*/}
             {/*id="jumpInput" />*/}
           {/*<a id={this.state.inputPage} onClick={this.gotoPage} style={{cursor: 'pointer'}}>确认</a>*/}
         {/*</p>*/}
      </div>
    )
  }
}

Pagination.propTypes = {
  page: PropTypes.number,
  perPage: PropTypes.number,
  total: PropTypes.number,
  setPage: PropTypes.func
}

export default Pagination



// WEBPACK FOOTER //
// ./components/grid/Pagination.js